// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetLedgersApiParameter } from "@store/Framework/Services/LedgerService";
import { LedgerCollectionModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { LedgersState } from "@store/Framework/Store/Store/Data/Ledgers/LedgersState";

const initialState: LedgersState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    ledgerDocumentTypes: [],
    ledgerStatuses: [],
    errorStatusCodeById: {},
};

const actions = {
    "Store/Data/Ledgers/BeginLoadLedgers": (
        draft: Draft<LedgersState>,
        action: { parameter: GetLedgersApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },
    "Store/Data/Ledgers/CompleteLoadLedgers": (
        draft: Draft<LedgersState>,
        action: { parameter: GetLedgersApiParameter; collection: LedgerCollectionModel },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection => collection.ledgerDetails ?? []);

        draft.ledgerDocumentTypes = action.collection.ledgerDocumentTypeCollection ?? [];
        draft.ledgerStatuses = action.collection.ledgerStatusCollection ?? [];
    },
    "Store/Data/Ledgers/FailedToLoadLedgers": (draft: Draft<LedgersState>) => {
        draft.failedToLoadLedgers = true;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type LedgersActions = Parameters<typeof reducer>[1];
export default reducer;
